const routes = [
    {
        path: "/code",
        name: "code_index",
        redirect: "/code/active",
        component: () => import("../views/code/index.vue"),
        meta: { h5Header: true, h5TitleKey: "user.tools.decrypt.title" },
        children: [
            {
                name: "code_active",
                path: "active",
                component: () => import("../views/code/code_active.vue"),
                meta: { h5TitleKey: "user.tools.decrypt.title" },
            },
        ],
    },
];

export default routes;
